import { memo } from "react";

interface ActiveAgent {
  name: string;
  task: string;
  startedAt: number;
}

interface AgentActivityBarProps {
  agents: ActiveAgent[];
}

export const AgentActivityBar = memo(function AgentActivityBar({ agents }: AgentActivityBarProps) {
  if (agents.length === 0) return null;

  const label = agents.length === 1
    ? `${agents[0].name}${agents[0].task ? ` — ${agents[0].task}` : " is working"}`
    : `${agents.length} agents working`;

  return (
    <div className="agent-activity-bar" role="status" aria-live="polite">
      <span className="agent-activity-icon" aria-hidden="true">✦</span>
      <span className="agent-activity-label">
        {label}
        <span className="streaming-dots" aria-hidden="true" />
      </span>
    </div>
  );
});
